// extracted by mini-css-extract-plugin
export default {"-large":"HreehOk_cdZMTJF4QXvg","container":"IcBReWz2vjfLSNGZhhbf","fontImage":"_hCewBf5rP6YfKXwoLbk","fontImgContainer":"KSC1Q4673o3ouUvUlJF5"};